(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('CalendarYearoverviewController', ['$uibModalInstance', CalendarYearoverviewControllerFn]);

    // controller for creating datepicker for each month of the year
    function CalendarYearoverviewControllerFn($uibModalInstance) {
        /* jshint validthis:true */
        var vm = this;

        vm.yearOverviewCalendars = [];
        vm.currentYear = null;

        // navigate year
        vm.navigateYear = navigateYear;

        // do activation
        activate();

        // close
        vm.close = function () {
            // close modal
            $uibModalInstance.close();
        };

        // function navigate year
        function navigateYear(direction) {
            if (vm.currentYear !== undefined && vm.currentYear !== null) {
                vm.currentYear = vm.currentYear + direction * 1;

                //rebuild calendars
                buildCalendars();
            }
        }

        // activate
        function activate() {
            // get current year
            vm.currentYear = new Date().getFullYear();
            buildCalendars();
        }

        // build calendars
        function buildCalendars() {
            // clear old calendar
            vm.yearOverviewCalendars = [];

            // create list with months for year
            for (var i = 0; i < 12; i++) {
                // virtuell id
                var id = new Date().getTime() + i;
                vm.yearOverviewCalendars.push({ id: id, month: i, year: vm.currentYear });
            }
        }
    }
})();
